import Vuex from 'vuex';
import Vue from 'vue';
import * as table from './table';
import {state, mutations, actions, getters} from './application';

const storeState = require.context('@/pages', true, /store.js$/);

const toFirstUpperCase = moduleName => moduleName.replace(/[/\\]/g, '_');

const modules = ((store) => {
  const module = {};
  store.keys().forEach(name => {
    const n = name.match(/\.[\\/]([^.]*)[\\/]store.js$/);
    const moduleName = n ? n[1] : 'root';
    const s = store(name);
    const m = s && s.default ? s.default : s;
    m.namespaced = true;
    module[toFirstUpperCase(moduleName)] = m;
  });
  return module;
})(storeState);

Vue.use(Vuex);

modules.table = {
  ...table,
  namespaced: true
};


const storage = {
  'home_gd_ha10/SET_ORDER_HISTORY': 'sessionStorage',
  'home_PK10/SET_ORDER_HISTORY': 'sessionStorage',
  'home_cc_ssc/SET_ORDER_HISTORY': 'sessionStorage'
};

const Storage = () => {
  return store => {

    for (const i in storage) {
      const s = storage[i];
      let data = window[s].getItem(`${s}:${i}`);
      try {
        data = JSON.parse(data);
      } catch (e) {
      }
      data && store.commit(i, data);
    }

    store.subscribe(({payload, type}) => {
      const s = storage[type];
      if (s) {
        try {
          payload = JSON.stringify(payload);
        } catch (e) {
        }
        window[s].setItem(`${s}:${type}`, payload);
      }
    });
  }
};

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules,
  plugins: [
    new Storage()
  ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js